import { render } from "./ProjectSummaryStretchGoal.vue?vue&type=template&id=b8e04b76"
import script from "./ProjectSummaryStretchGoal.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryStretchGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__